import { IDealRoomShare } from '@app/interfaces/deal-room';
import { IDealRoomPeople } from '@app/interfaces/deal-room-people';
import { isObject } from 'lodash';
import { useEffect } from 'react';

interface MedianCoBrowseProps {
  dealRoom: IDealRoomShare;
  people: IDealRoomPeople;
}

export const MedianCoBrowse: React.FC<MedianCoBrowseProps> = ({ dealRoom, people }) => {
  const name = `חדר אישי: ${dealRoom?.title || ''} | ${
    isObject(dealRoom?.client) && dealRoom?.client?.id_num ? dealRoom.client.id_num : ''
  } | ${people?.firstName || ''} ${people?.lastName || ''} | ${people?.phone || ''}`;

  useEffect(() => {
    if (!name) return;

    (function () {
      let Median = window.Median;
      if (!Array.isArray(Median)) {
        Median = [];
      }
      window.Median = Median;

      if (Median._initialized) return;
      if (Median._snippet_loaded) {
        // eslint-disable-next-line no-console
        console.warn('Median Snippet loaded twice.');
        return;
      }

      Median._snippet_loaded = true;
      Median._snippet_version = 3;
      Median.methods = ['init', 'identify', 'endSession', 'on'];
      Median.factory = function (n) {
        return function () {
          // eslint-disable-next-line prefer-rest-params
          const t = Array.prototype.slice.call(arguments);
          Median.push([n, t]);
        };
      };
      for (let n = 0; n < Median.methods.length; n++) {
        const t = Median.methods[n];
        (Median as typeof Median & { [key in typeof t]: ReturnType<NonNullable<typeof Median.factory>> })[t] =
          Median.factory(t);
      }

      const i = document.createElement('script');
      i.type = 'text/javascript';
      i.async = true;
      i.src = 'https://js.hellomedian.com/v1/mdn-screenshare.js';
      const a = document.getElementsByTagName('script')[0];
      if (a && a.parentNode) {
        a.parentNode.insertBefore(i, a);
      }

      // Once the script loads, these calls will be replayed
      if (
        process.env.REACT_APP_MEDIAN_BROWSER_ID &&
        window.Median &&
        typeof window.Median.init === 'function' &&
        typeof window.Median.identify === 'function'
      ) {
        window.Median.init(process.env.REACT_APP_MEDIAN_BROWSER_ID);
        window.Median.identify(name);
      }
    })();
  }, [name]);

  return <></>;
};
